"use client"

import styled from "@emotion/styled"
import { GetPageQuery } from "apollo"
import { ScrollingProvider } from "contexts/ScrollingProvider"
import { HomeIcon } from "ui/icons"

import {
  PointsOfInterestDtoPaginatedList,
  SearchMetaDataDto,
  TableDto,
} from "api"
import { getParentsArray } from "lib/utils"
import colors from "theme/colors"
import { CustomBreadcrumbs, MainContainer } from "ui"
import { BlockRenderer, findProperty } from "utils"
import JoiningPazomat from "./JoiningPazomat"
import PazomatBanner from "./PazomatBanner"
import PazomatFiles from "./PazomatFiles"
import PazomatMap from "./PazomatMap"
import PazomatPrice from "./PazomatPrice"
import PazomatQuote from "./PazomatQuote"
import SwiperPazoma from "./SwiperPazoma"

const StyledMainDiv = styled.div`
  width: 100%;
`
function Pazomat({
  data,
  listData,
}: {
  data: GetPageQuery
  listData: {
    prices: TableDto
    diplomats: TableDto
    services: TableDto
  }
  gasMetadata: SearchMetaDataDto
  gasStations: PointsOfInterestDtoPaginatedList
}) {
  const components = {
    topBanner: PazomatBanner,
    contentText: PazomatQuote,
    joinPazomatBox: JoiningPazomat,
    servicesSarouselM: SwiperPazoma,
    baseBlock: PazomatPrice,
    fileAccordionContainer: PazomatFiles,
    serviceLocator: PazomatMap,
  }
  const parents = getParentsArray(data.page, 3)
  return (
    <StyledMainDiv>
      <MainContainer rightGap={220} mediumRightGap={146}>
        <CustomBreadcrumbs
          current={{ title: "פזומט", url: `/` }}
          parents={[
            { title: <HomeIcon />, url: "/" },
            ...parents.slice(0, -1),
          ]}
        />
      </MainContainer>

      <ScrollingProvider minOffsetShow={200}>
        {findProperty(data, "blocks")?.blocks?.map(
          // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
          (block: any, index: number) => {
            let sideMenuTitle = block.properties.find(
              (prop: any) => prop.propertyName === "sideMenuTitle",
            )?.propertyValue?.value
            let addProps = {}
            if (block.blockType === "contentText") {
              addProps = {
                titlePropertyName: "conetntTitle",
                textPropertyName: "innerText",
                linkPropertyName: "link",
                textType: "rich",
                titleColor: colors.black,
                titleWithLine: true,
              }
            } else if (block.blockType === "baseBlock") {
              addProps = {
                listData,
              }
            } else if (block.blockType === "serviceLocator") {
              sideMenuTitle = block.properties.find(
                (prop: any) => prop.propertyName === "title",
              )?.propertyValue?.value
            }
            return sideMenuTitle ? (
              <section
                key={index.toString()}
                id={sideMenuTitle || index.toString()}
              >
                <BlockRenderer
                  key={index}
                  blockType={block.blockType}
                  blockData={block}
                  components={components}
                  props={addProps}
                ></BlockRenderer>
              </section>
            ) : (
              <BlockRenderer
                key={index}
                blockType={block.blockType}
                blockData={block}
                components={components}
                props={addProps}
              ></BlockRenderer>
            )
          },
        )}
      </ScrollingProvider>
    </StyledMainDiv>
  )
}

export default Pazomat
